export function BZCRichLinkAManoBoxViewConstructor(services, callbacks, context, siteTypeConfig) {
  
  let joint = services.joint;
  let companyId = context.companyId;
  let siteId = context.site.id;

  return joint.shapes.html.AbstractBoxElementView.extend({

    template: [
      '<div class="html-element media-or-button-template">',
        '<div class="box-content-container">',
          '<div class="box-content">',
            '<div class="media-template-content">',
              '<img src="" class="hide">',
              '<video preload="auto" controls src="" class="hide"></video>',
            '</div>',          
            '<div class="rich-link-text-content">',
              '<div class="rich-link-title"></div>',
              '<div class="rich-link-url"></div>',
            '</div>',
          '</div>',
          '<div class="item-edit-container"><span class="glyphicon glyphicon-pencil item-edit"></span></div>',
        '</div>',
      '</div>'
    ].join(''),


    initialize: function() {

      joint.shapes.html.AbstractBoxElementView.prototype.initialize.apply(this, arguments);

      // this.$box is initialized by the abstract superclass
      this.$box.find('.item-edit').on('click', () => this.edit());
      this.$box.find('img').load(() => {
        if (!services.JointjsOptimisationsFactory.isDeserializingInProgress() && !this.model.get('rich_link').videoId) {
          // do not resize if there is also a video, as this would create an infinite loop of resizes and reloads
          this.resizeBox();
        }
      });
      this.$box.find('video')[0].addEventListener('loadeddata', () => this.resizeBox(), false);
    },


    /**
     * Event handler that shows a modal for editing the generic template 
     */
    edit : function() {
      const element = this.model.get('rich_link');
      let modalInstance = services.$uibModal.open({
        animation: true,
        template:  require('../shared/editTemplateElement.modal.html'),
        controller: 'editTemplateElementController',
          resolve: {
            companyId: () => companyId,
            siteId: () => siteId,
            templateType: () => this.model.get('type'),
            element: () => angular.copy(element),
            modalTitle: () => services.$translate.instant('parameters/quick_replies/details/edit_generic_template_a_mano/title'),
            showRemoveButton: () => false,
            showCompactCheckbox: false
          }
      });
      // Hook callback that will update the model and save the updated graph
      modalInstance.result.then(result => {  
        if (result.type === 'edit') {
          this.model.set('rich_link', result.element);
        }
        callbacks.updateSerializedGraph(this.model.graph);
        this.resizeBox();
      });
    },


    updateBox: function() {
      if (this.paper && this.model.get('rich_link')) {
        const element = this.model.get('rich_link');
        const img = this.$box.find('img');
        if (typeof element.pictureId === 'number') {
          img.removeClass('hide');
          services.MediasFactory.pictureUrlWithJWT(companyId, element.pictureId).then((urlWithJwt) => {
            img.attr('src', urlWithJwt);
          });
        } else {
          img.addClass('hide');
        }
        const video = this.$box.find('video');
        if (typeof element.videoId === 'number') {
          video.removeClass('hide');
          services.MediasFactory.videoUrlWithJWT(companyId, element.videoId).then((urlWithJwt) => {
            video.attr('src', urlWithJwt);
          });
        } else {
          video.addClass('hide');
        }
        this.$box.find('.rich-link-title').text(element.title);
        this.$box.find('.rich-link-url').text(element.url);  
      }
      joint.shapes.html.AbstractBoxElementView.prototype.updateBox.apply(this, arguments);
    },

    
    resizeBox: function() {
      if (services.JointjsOptimisationsFactory.logCallsToResize()) {
        console.warn('BZCRichLinkAManoBoxView - resizeBox()');
      }
      let box = this.model;
      let embeddedCells = box.getEmbeddedCells();
      let paddingTop = this.$box.find('.box-content-container').outerHeight();

      //Reposition and resize every item
      let ypos = paddingTop ;
      for (let child of embeddedCells) {
        let childView = this.paper.findViewByModel(child);
        child.position(0, ypos, {parentRelative: true});
        let childHeight = childView.$box.outerHeight();
        child.resize(box.attributes.size.width, childHeight);
        ypos += childHeight;
      }

      box.fitEmbeds({padding: {top: paddingTop, right: 0, bottom: 0, left: 0}});
      callbacks.resizePaper();
    }
  });
}